<template>
	<div class="model1">
		<div class="model1_box1">
			<div class="m1_top_box" style="margin-top:16px;">
				<!-- show_type字段
                1-0 显示 区域     国家
                1-1 显示  区域     省份
                1-3显示   交易所 -->
				<div class="m1_top_lbox">
					<span v-if="currentModel == '1-0'">区域：</span>
					<span v-if="currentModel == '1-1'">区域：</span>
					<span v-if="currentModel == '1-3'">交易所：</span>
					<span v-if="currentModel == '1-4'">行业：</span>
				</div>
				<div
					class="m1_top_rbox  m1_top_1"
					v-if="currentModel != '1-3' && currentModel != '1-4'"
				>
					<span
						v-for="(item, index) in areaData"
						:key="index"
						@click="changeInfo(1, index)"
						:class="index == 0 ? 'active' : ''"
						>{{ item.areaName }}</span
					>
				</div>
				<div
					class="m1_top_rbox m1_tag m1_top_4"
					v-if="currentModel == '1-4'"
				>
					<span
						v-for="(item, index) in areaData"
						:key="index"
						@click="changeInfo(4, index)"
						:class="index == 0 ? 'active' : ''"
					>
						{{ item.name }}
					</span>
				</div>
			</div>

			<div
				v-if="currentModel != '1-3' && currentModel != '1-4'"
				class="m1_top_box"
			>
				<div v-if="chooseArea.length > 0" class="m1_top_lbox">
					<span v-if="currentModel == '1-0'">国家：</span>
					<span v-if="currentModel == '1-1'">省份：</span>
				</div>
				<div v-if="chooseArea.length > 0" class="m1_top_rbox m1_top_2">
					<span
						v-for="(item, index) in chooseArea"
						:key="index"
						@click="changeInfo(2, index)"
						>{{ item.areaName }}</span
					>

					<el-button
						class="showboxbtn"
						@click="showHideBox"
						style="position: absolute;top: 0;right: 1px;padding: 3px;"
						size="mini"
						icon="el-icon-bottom"
						circle
					></el-button>

					<i
						v-if="!chooseArea || chooseArea.length <= 0"
						style="font-style: normal;display: block;color:#ccc;"
						>暂无数据</i
					>
				</div>
			</div>
			<!-- <div class="m1_top_box">
                <div class="m1_top_lbox">
                    <span style="padding-top: 5px;">时间：</span>
                </div>
                <div class="m1_top_rbox m1_top_3">
                    <span @click="changeInfo(3,-1)" class="active">不限</span>
                    <span @click="changeInfo(3,0)">一周内</span>
                    <span @click="changeInfo(3,1)">一月内</span>
                    <span @click="changeInfo(3,2)">一年内</span>
                    <i style="font-style:normal;">自定义:</i>
                    <el-date-picker
                        @change="changeDateFn"
                        style="width:250px;margin-left:12px;border:1px solid #F3F3F3;"
                        size="small"
                        v-model="dateRaneg"
                        unlink-panels
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div> -->
		</div>
		<div class="model1_box2">
			<!-- 文章列表部分 -->
			<div class="m1_info_box">
				<!-- <h5><img src="../assets/main/title_icon.jpg" alt=""> </h5> -->
				<ul class="m1_info_ul" style="margin-top:20px;">
					<li v-for="(item, index) in dataList" :key="index">
						<a
							class="m1_info_li_l"
							:href="
								'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
									item.docid +
									'&leafid=' +
									item.leafid
							"
							target="_blank"
						>
							<h6>{{ item.deliveddate | subData2 }}</h6>
							<span>{{ item.deliveddate | subData1 }}</span>
						</a>
						<a
							class="m1_info_li_r"
							:href="
								'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
									item.docid +
									'&leafid=' +
									item.leafid
							"
							target="_blank"
						>
							<h6
								v-html="
									item.title.replace(
										/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
										''
									)
								"
							></h6>
							<span
								v-html="
									item.summary.replace(
										/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
										''
									)
								"
							></span>
						</a>
					</li>
					<el-empty
						v-if="dataList.length <= 0 && loading == false"
						description="暂无数据!"
					></el-empty>
					<el-empty
						v-if="loading == true"
						description="加载中!"
					></el-empty>
				</ul>
				<div class="pagination_box">
					<el-pagination
						v-if="dataList.length > 0"
						background
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-size="pagesize"
						layout="total, prev, pager, next, jumper"
						:total="total"
					>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';

export default {
	// 国际概览 ——带多条件查询
	props: ['currentChoose', 'currentModel'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			loading: false, //表格加载
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			areaData: [], //地区数据
			chooseArea: [], //当前展示国家集合
			keyword: '', //当前选中的地区或者国家
		};
	},
	watch: {
		currentChoose(val) {
			this.currentPage = 1;
			// this.keyword = this.areaData[0].areaName;
			this.keyword = '';
			this.dataType = ''; //时间初始化
			this.fetchDataList(val); //获取文章列表
			// this.changeInfo(1,0);//地区初始化

			$('.m1_top_1 span').removeClass('active');
			$('.m1_top_1 span')
				.eq(0)
				.addClass('active');

			$('.m1_top_2 span').removeClass('active');
			$('.m1_top_2 span')
				.eq(0)
				.addClass('active');

			$('.m1_top_3 span').removeClass('active');
			$('.m1_top_3 span')
				.eq(0)
				.addClass('active');
		},
		currentModel(val) {
			let _id = '';
			this.currentModel == '1-0' ? (_id = 0) : '';
			this.currentModel == '1-1' ? (_id = -1) : '';
			this.currentModel == '1-2' ? (_id = -2) : '';
			//  新增：行业
			if (this.currentModel == '1-4') {
				this.fetchIndustryData();
			} else {
				this.fetchAreaData(_id);
			}
		},
	},
	mounted() {
		let _id = '';
		this.currentModel == '1-0' ? (_id = 0) : '';
		this.currentModel == '1-1' ? (_id = -1) : '';
		this.currentModel == '1-2' ? (_id = -2) : '';
		//  新增：行业
		if (this.currentModel == '1-4') {
			// 行业模式下只执行一次
			this.fetchIndustryData();
		} else {
			this.fetchAreaData(_id);
		}
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);

			//console.log(this.chooseArea, 'this.chooseArea');
			// this.keyword = this.chooseArea[0].areaName;
			this.keyword = '';
			this.fetchDataList(this.currentChoose);
			// if (this.currentModel !== '1-4') {
			// 	this.fetchDataList(this.currentChoose);
			// }
			// 新增逻辑：根据 query.names 自动选中对应区域
			if (this.$route.query.newAreaName) {
				let targetName = this.$route.query.newAreaName;

				// 遍历所有区域
				this.areaData.forEach((area, areaIndex) => {
					if (area.childList && area.childList.length > 0) {
						// 在子列表找匹配的名字
						let childIndex = area.childList.findIndex(
							(c) => c.areaName === targetName
						);
						if (childIndex !== -1) {
							// 先选中大区域
							this.changeInfo(1, areaIndex);
							// 再选中具体的省份/国家
							setTimeout(() => {
								this.changeInfo(2, childIndex);
							}, 300);
						}
					}
				});
			}
			if (this.$route.query.areaType && this.$route.query.areaName) {
				if (this.$route.query.areaType) {
					this.changeInfo(
						1,
						this.areaData.findIndex(
							(item) =>
								item.areaName == this.$route.query.areaType
						)
					);
					if (this.$route.query.areaName) {
						setTimeout(() => {
							this.changeInfo(
								2,
								this.chooseArea.findIndex(
									(item) =>
										item.areaName ==
										this.$route.query.areaName
								)
							);
						}, 400);
					}
				}
			}
			// 如果路由带了 tag，就自动选中
			if (this.$route.query.tag) {
				// 如果有 tag，选中对应
				let tagIndex = this.areaData.findIndex(
					(t) => t.name === this.$route.query.tag
				);

				if (tagIndex !== -1) {
					this.changeInfo(4, tagIndex);
				} else {
					// 如果没找到，默认不限
					this.changeInfo(4, 0);
				}
			} else {
				// 🚀 默认不限
				this.changeInfo(4, 0);
			}
		}, 400);
	},
	methods: {
		//点击显示隐藏国家高度，默认只显示第一行
		showHideBox() {
			$('.m1_top_rbox').css('height', 'auto');
			$('.showboxbtn').css('display', 'none');
		},
		// ✅ 新增：获取行业标签
		fetchIndustryData() {
			api.getInfoTagsListByType('focus').then((res) => {
				if (res.data) {
					this.areaData = res.data;
					// 判断是否已有“不限”
					const hasNoLimit = this.areaData.some(
						(item) => item.name === '不限'
					);
					if (!hasNoLimit) {
						// 没有则加到最前面
						this.areaData.unshift({
							name: '不限',
							value: '',
						});
					}
				}
			});
		},
		//获取数据列表
		fetchAreaData(id) {
			let _this = this;
			api.getAreaData(id).then((res) => {
				if (res.data) {
					//console.log(res, 'area');
					_this.areaData = res.data;
					_this.chooseArea = res.data[0].childList
						? res.data[0].childList
						: [];
				}
			});
		},
		changeInfo(num, i) {
			if (num == 1) {
				// 区域
				$('.m1_top_1 span').removeClass('active');
				$('.m1_top_1 span')
					.eq(i)
					.addClass('active');

				this.chooseArea = this.areaData[i].childList
					? this.areaData[i].childList
					: [];
				this.keyword =
					this.areaData[i].areaName == '不限'
						? ''
						: this.areaData[i].areaName;
				this.fetchDataList(this.currentChoose);

				setTimeout(() => {
					$('.m1_top_2 span').removeClass('active');
					$('.m1_top_2 span')
						.eq(0)
						.addClass('active');
				}, 300);
			}

			if (num == 2) {
				// 国家
				$('.m1_top_2 span').removeClass('active');
				$('.m1_top_2 span')
					.eq(i)
					.addClass('active');
				//console.log($('.m1_top_rbox.m1_top_1 .active').html(), 44);
				this.chooseArea[i].areaName == '不限'
					? (this.keyword = $('.m1_top_rbox.m1_top_1 .active').html())
					: (this.keyword = this.chooseArea[i].areaName);
				this.fetchDataList(this.currentChoose);
			}

			if (num == 3) {
				// 时间
				$('.m1_top_3 span').removeClass('active');
				$('.m1_top_3 span')
					.eq(i + 1)
					.addClass('active');
				this.dataType = i == -1 ? '' : i;
				this.startDate = '';
				this.endDate = '';
				this.dateRaneg = [];
				this.fetchDataList(this.currentChoose);
			}
			//新增：行业
			if (num == 4) {
				$('.m1_top_4 span').removeClass('active');
				$('.m1_top_4 span')
					.eq(i)
					.addClass('active');
				console.log(this.areaData[i].name);

				this.keyword = this.areaData[i].name;

				this.fetchDataList(this.currentChoose);
			}
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.dataType = '';
				$('.m1_top_3 span').removeClass('active');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
		},
		//获取数据列表
		fetchDataList(_uid) {
			// dateType：0是 一周 1 是一个月 2 是一年;"startDate":"2022-05-01","endDate":"2022-05-02"
			let params = {
				uid: _uid,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				dateType: this.dataType,
				startDate: this.startDate,
				endDate: this.endDate,
				keyword: this.keyword == '不限' ? '' : this.keyword,
			};
			this.loading = true; //表格加载
			//console.log(params, 'params');
			api.getarticleList(params).then((res) => {
				if (res.data) {
					//console.log(res, 'list');
					this.dataList = res.data.rows;
					this.total = res.data.total;
					this.loading = false; //表格加载
				}
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	// width: 100%;
	height: 100%;
	overflow: hidden;
}
.model1_box1 {
	width: 890px;
	// min-height:185px;
	background: #fff;
	overflow: hidden;
	padding: 14px 30px;
	margin-bottom: 20px;
}
.model1_box2 {
	background: #fff;
	width: 890px;
	overflow: hidden;
	padding: 0 30px 14px;
}

//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 10px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}

.m1_info_ul {
	width: 100%;
	overflow: hidden;
}
.m1_info_ul li {
	width: 100%;
	height: 77px;
	border-bottom: 1px solid #e7ede5;
	padding: 30px 0;
	cursor: pointer;
}

.m1_info_li_l {
	width: 126px;
	height: 100%;
	text-align: center;
	float: left;
	border-right: 1px solid #f3f3f3;
}
.m1_info_li_l h6 {
	font-size: 22px;
	font-family: Arial;
	font-weight: 400;
	color: #1b1b1b;
	width: 100%;
	text-align: center;
}
.m1_info_li_l span {
	width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.m1_info_li_r {
	padding-left: 36px;
	float: left;
	width: 625px;
}
.m1_info_li_r h6 {
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #4d4d4d;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-bottom: 6px;
}
.m1_info_li_r h6:hover {
	color: #4eac41;
}
.m1_info_li_r span {
	display: block;
	width: 100%;
	line-height: 24px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* 这里是超出几行省略 */
	overflow: hidden;
}
// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
// top条件搜索
.m1_top_box {
	width: 100%;
	overflow: hidden;
}
.m1_top_lbox {
	width: 70px;
	float: left;
}
.m1_top_lbox span {
	width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #191919;
}
.m1_top_rbox {
	width: 700px;
	height: 30px;
	float: left;
	position: relative;
}
.m1_tag {
	width: 89% !important;
	height: auto !important;
	float: left;
	position: relative;
}
.m1_top_rbox span {
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #222222;
	margin-right: 20px;
	margin-bottom: 12px;
	cursor: pointer;
	display: inline-block;
}
.el-range-editor--small.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_top_rbox span.active {
	color: #4eac41;
}
</style>



// WEBPACK FOOTER //
// src/components/mode3.vue